import React from 'react';
import { Award, ExternalLink, CheckCircle, X } from 'lucide-react';
export function ClosingSection() {
  return <div className="bg-white py-16 border-t border-[#E8E4DD]" data-id="element-5">
      <div className="editorial-container" data-id="element-6">
        {/* Why Faith & Fig Took the #1 Spot */}
        <div className="mb-12" data-id="element-7">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-8">
            Why Faith & Fig 4:14 Saffron Took the #1 Spot
          </h2>
          <div className="prose prose-lg max-w-none" data-id="element-9">
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-10">
              <strong data-id="element-11">The Right Dosing:</strong> 30mg of clinically studied{' '}
              <a href="https://activinside.com/ingredients/safrinside/" target="_blank" rel="noopener noreferrer" className="text-[#C9A961] hover:text-[#B89851] underline" data-id="element-12">
                Safr'Inside™
              </a>{' '}
              saffron extract the exact amount shown in research to work as
              effectively as Ritalin without the side-effects.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-13">
              <strong data-id="element-14">The Right Mechanism:</strong> Supports the complete
              calm-focus-regulation cycle, not just one fragment.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-15">
              <strong data-id="element-16">The Right Values:</strong> Faith-aligned, addresses guilt,
              honors stewardship of the mind God gave you.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed" data-id="element-17">
              <strong data-id="element-18">The Right Results:</strong> Calmer mornings, steadier
              focus, better emotional control, spiritual presence restored.
            </p>
          </div>
        </div>

        {/* Why You Should Stop Relying on Willpower Alone */}
        <div className="mb-12" data-id="element-19">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-20">
            Why You Should Stop Relying on Willpower Alone
          </h2>
          <div className="prose prose-lg max-w-none" data-id="element-21">
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-22">
              Many Christian women think they just need to "try harder," pray
              more, or be more disciplined. But if your brain's
              calm-regulate-focus circuit is breaking down, no amount of
              willpower will fix it.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed" data-id="element-23">
              Saffron offers gentle, natural support for the system itself so
              your prayer, discipline, and effort can actually stick.
            </p>
          </div>
        </div>

        {/* Buying Guide */}
        <div className="mb-12" data-id="element-24">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-25">
            Buying Guide: What to Look For in a Natural Supplement
          </h2>

          <div className="bg-white border border-[#E8E4DD] rounded-xl p-8 mb-6" data-id="element-26">
            <ul className="space-y-3" data-id="element-27">
              {['Clinically-dosed active ingredients (not under-dosed to cut costs)', 'Research backing for AD*D specifically (not just "brain health")', 'Full-cycle support (calm + focus + emotional regulation together)', 'Single-ingredient purity or transparent formulas (no mystery blends)', 'Faith-friendly brand (understands your values and concerns)', 'Money-back guarantee (shows the company stands behind results)'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-28">
                  <CheckCircle className="w-5 h-5 text-[#C9A961] flex-shrink-0 mt-0.5" data-id="element-29" />
                  <span className="text-[#1A2332]/80" data-id="element-30">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50 border border-red-200 rounded-xl p-8" data-id="element-31">
            <h3 className="text-xl font-bold text-[#1A2332] mb-4" data-id="element-32">
              Red Flags to Avoid:
            </h3>
            <ul className="space-y-3" data-id="element-33">
              {['Vague proprietary blends', 'Under-dosed saffron or missing clinical amounts', 'Stimulant-heavy formulas that cause jitters or anxiety', 'No specific clinical trials to back up claims'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-34">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-35" />
                  <span className="text-[#1A2332]/80" data-id="element-36">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

       
        <div className="mb-12" data-id="element-37">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-38">
            Is Saffron Supplementation the Answer?
          </h2>
          <div className="prose prose-lg max-w-none" data-id="element-39">
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-40">
              Nothing is a magic bullet, and saffron isn't a replacement for
              prayer, good habits, or responsible medical care when needed.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-41">
              But when well-formulated and when dosed according to clinical
              research saffron can make a meaningful difference in your ability
              to stay calm, focused, and emotionally steady throughout your day.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed" data-id="element-42">
              Think of it this way: You wouldn't feel guilty for wearing glasses
              to see clearly. Why feel guilty for supporting your brain to focus
              clearly?
            </p>
          </div>
        </div>

        {/* Special Offer Section */}
        <div className="bg-[#C9A961]/5 border-l-4 border-[#C9A961] p-8 rounded-r-xl mb-12" data-id="element-43">
          <h2 className="text-2xl font-bold text-[#1A2332] mb-4" data-id="element-44">
            Special Offer for HerMindBodySoul Readers:
          </h2>
          <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-45">
            We reached out to Faith&Fig after our testing, and they agreed to
            extend their Black Friday offer:
          </p>
          <ul className="space-y-3" data-id="element-46">
            {['Up to 40% OFF multi-month bundles', 'Free U.S. shipping on your first order', '90-day money-back guarantee (because they know it works)'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-47">
                <span className="text-[#C9A961] font-bold text-lg" data-id="element-48">✓</span>
                <span className="text-[#1A2332]/80" data-id="element-49">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Final CTA Box - Our Top Pick */}
        <div className="bg-gradient-to-br from-[#1A2332] to-[#1A2332]/90 text-white p-8 rounded-xl shadow-xl" data-id="element-50">
          <div className="flex items-start gap-4 mb-6" data-id="element-51">
            <Award className="w-8 h-8 text-[#C9A961] flex-shrink-0" data-id="element-52" />
            <div data-id="element-53">
              <h3 className="text-2xl font-bold mb-2" data-id="element-54">
                Our Top Pick – Faith & Fig 4:14 Saffron
              </h3>
            </div>
          </div>

          <ul className="space-y-3 mb-8" data-id="element-55">
            {[<>
                Clinically-dosed saffron (30mg{' '}
                <a href="https://activinside.com/ingredients/safrinside/" target="_blank" rel="noopener noreferrer" className="text-[#C9A961] hover:text-[#B89851] underline" data-id="element-56">
                  Safr'Inside™
                </a>
                )
              </>, 'Supports calm-focus-regulation cycle', 'Biblical botanical (Song of Solomon 4:14)', 'No emotional blunting or stimulant side effects', 'Thousands of Christian women report life-changing results'].map((highlight, index) => <li key={index} className="flex items-start gap-3" data-id="element-57">
                <span className="text-[#C9A961] font-bold" data-id="element-58">✓</span>
                <span className="text-white/90" data-id="element-59">{highlight}</span>
              </li>)}
          </ul>

          <a href="https://trysaffron.faithandfig.com" target="_blank" rel="noopener noreferrer" className="block" data-id="element-60">
            <button className="w-full bg-[#C9A961] hover:bg-[#C9A961]/90 text-white font-bold py-4 px-8 rounded-lg transition-colors flex items-center justify-center gap-2 text-lg" data-id="element-61">
              Try 4:14 Saffron Risk-Free →
              <ExternalLink className="w-5 h-5" data-id="element-62" />
            </button>
          </a>
        </div>

        {/* Legal Disclaimer */}
        <div className="mt-12 pt-8 border-t border-[#E8E4DD]" data-id="element-63">
          <h3 className="text-sm font-bold text-[#1A2332]/70 mb-3" data-id="element-64">
            Disclaimer
          </h3>
          <p className="text-xs text-[#1A2332]/50 leading-relaxed" data-id="element-65">
            4:14 Saffron is a botanical and not a prescription medication. It is not intended to diagnose, treat, cure, or prevent any disease. It should not be considered a replacement for professional medical advice or treatment. Always consult your doctor before starting any new supplement, especially if you are pregnant, nursing, taking medication, or have any medical conditions.
            This article is for informational purposes only and is not intended
            to diagnose, treat, cure, or prevent any disease. Always consult
            your healthcare provider before starting any new supplement,
            especially if you are pregnant, nursing, taking medications, or have
            a medical condition. Statements regarding dietary supplements have
            not been evaluated by the FDA. Individual results may vary. . For legal and compliance reasons, we do not compare Saffron 4:14 to prescription medications. No images or brand names of such medications are shown on this page. The statements on this page have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure, or prevent any disease. Individual results may vary. This is an independent review and not affiliated with any pharmaceutical company. 
          </p>
        </div>
      </div>
    </div>;
}